<template>
  <Content :button-create-show="!!selected_m" :create-id="selected_m">
    <template #body>
      <p>Город:</p>
      <el-select
        v-model="selected_c"
        :multiple="false"
        placeholder="Выберте город"
        filterable
        clearable
        style="width: 100%"
      >
        <el-option
          v-for="item in cities"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <p>Музей / площадка:</p>
      <el-select
        v-model="selected_m"
        :multiple="false"
        :disabled="!selected_c"
        placeholder="Выберте музей / площадку"
        filterable
        clearable
        style="width: 100%; margin-bottom: 30px"
      >
        <el-option
          v-for="item in museums"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <Table
        v-if="selected_m"
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data-id="methods.fetchData"
        :method-delete-row="methods.deleteRow"
        :by-id="id"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";
import { getMuseums } from "@/api/museums";
import { getCities } from "@/api/cities";

import {
  getMuseumActivations as fetchData,
  deleteMuseumActivation as deleteRow,
} from "@/api/activations";

const columnsOptions = {
  sortable: "custom",
  controls: true,
  edit: true,
  id: "id",
  delete_row: {
    buttonName: "Удалить",
  },
};

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 50,
  },
  {
    prop: "imageLink",
    label: "Иконка активации",
    type: "preview",
  },
  {
    prop: "text",
    label: "Основной текст",
  },
  {
    prop: "description",
    label: "Описание",
  },
  {
    prop: "order",
    label: "Порядок",
  },
  {
    prop: "buttonListen",
    label: "Кнопка 'Слушать'",
    type: "bool",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      selected_c: null,
      selected_m: null,
      museums: null,
      cities: null,
      id: null,
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData,
        deleteRow,
      },
    };
  },
  async created() {
    const data = await getCities();
    this.cities = data;
    this.selected_c = this.cities[0].id;
  },
  watch: {
    selected_c(val) {
      this.fetchMuseums(val);
      this.selected_m = null;
    },
    selected_m(val) {
      this.id = val;
    },
  },
  methods: {
    async fetchMuseums(cityId) {
      const data = await getMuseums(cityId, { cityId: cityId });
      this.museums = data;
      if (!this.selected_m && this.museums.length)
        this.selected_m = this.museums[0].id;
    },
  },
};
</script>
